import { i18n } from "../../../boot/i18n";
// import store from "../../../store/index";

export default {
  routes: [
    {
      name: "service-leads",
      path: "service-leads/:filter?",
      meta: { icon: "service", title: i18n.global.t("Service Center") },
      component: () => import("pages/employee/ServiceLeads"),
    },
    {
      name: "service-leads-widget",
      path: "service-leads/widget/:widget",
      props: true,
      meta: { icon: "service", title: i18n.global.t("Service Center") },
      component: () => import("pages/employee/ServiceLeads"),
    },
    {
      name: "technician-work-order",
      path: "service-work-order/:workOrderID",
      meta: { icon: "service", title: i18n.global.t("Service Work Order") },
      component: () => import("pages/employee/TechnicianWorkOrder"),
      props: true,
    },
    {
      name: "service-report",
      path: "service-report/:workOrderID",
      meta: { icon: "description", title: i18n.global.t("Service Report") },
      component: () => import("pages/employee/ServiceReport"),
      props: true,
    },
    {
      name: "service-issues",
      path: "service-issues/:filter?/:query?",
      meta: { icon: "issue", title: i18n.global.t("Service Issues") },
      component: () => import("pages/employee/ServiceIssues"),
    },
    {
      name: "active-service",
      path: "active-service/:filter?",
      meta: { icon: "service", title: i18n.global.t("Active Service") },
      component: () => import("pages/employee/ActiveService"),
    },
    {
      name: "previously-completed",
      path: "previously-completed",
      meta: { icon: "done_all", title: i18n.global.t("Previously Completed") },
      component: () => import("pages/employee/PreviouslyCompleted"),
    },
    {
      name: "knowledge-base",
      path: "knowledge-base",
      meta: { icon: "knowledge", title: i18n.global.t("Knowledge Base") },
      component: () => import("pages/employee/KnowledgeBase"),
    },
  ],

  dialogs: [
    {
      name: "service-issue-new",
      path: "/service-issues/new",
      meta: {
        icon: "issue",
        title: i18n.global.t("New Service Issue"),
      },
      component: () => import("../../../dialogs/employee/ServiceIssueEdit"),
    },
    {
      // Same dialog, pre-scoped to a project. Separate route because
      // `route-matcher` (the dialog router) has no `:param?` support.
      name: "service-issue-project-new",
      path: "/service-issues/new/:projectID",
      meta: {
        icon: "issue",
        title: i18n.global.t("New Service Issue"),
      },
      component: () => import("../../../dialogs/employee/ServiceIssueEdit"),
    },
    {
      name: "service-issue-edit",
      path: "/service-issues/:issueID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Service Issue"),
      },
      component: () => import("../../../dialogs/employee/ServiceIssueEdit"),
    },
    {
      name: "service-issue-view",
      path: "/service-issues/:issueID/view",
      meta: {
        icon: "issue",
        title: i18n.global.t("Service Issue"),
      },
      component: () => import("../../../dialogs/employee/ServiceIssueView"),
    },
    {
      name: "service-work-order-new",
      path: "/service-work-orders/new",
      meta: {
        icon: "work",
        title: i18n.global.t("New Work Order"),
      },
      component: () => import("../../../dialogs/employee/ServiceWorkOrderEdit"),
    },
    {
      // "Create Work Order" from a service issue: the caller has the issue's
      // project / sale / issue IDs but no schedule yet. Separate route for the
      // same no-optional-params reason — `service-work-order-new` has no
      // params (route-matcher would drop all three) and
      // `service-work-order-scheduled-new` demands four schedule segments
      // this caller doesn't have. `([^/]*)` groups match empty segments, so a
      // blank saleID is safe.
      name: "service-work-order-issue-new",
      path: "/service-work-orders/new/:projectID/:saleID/:issueID",
      meta: {
        icon: "work",
        title: i18n.global.t("New Work Order"),
      },
      component: () => import("../../../dialogs/employee/ServiceWorkOrderEdit"),
    },
    {
      // Scheduler / issue-view entry point: every slot is filled in by the
      // caller. Separate route for the same no-optional-params reason.
      name: "service-work-order-scheduled-new",
      path: "/service-work-orders/new/:scheduledStart/:scheduledEnd/:assignedTechs/:assignedVehicles/:projectID/:saleID/:issueID",
      meta: {
        icon: "work",
        title: i18n.global.t("New Work Order"),
      },
      component: () => import("../../../dialogs/employee/ServiceWorkOrderEdit"),
    },
    {
      // A scheduler slot picked for an EXISTING work order ("Save &
      // Schedule" saves it undated, then opens the scheduler): the slot is
      // applied to that work order instead of starting another one.
      name: "service-work-order-scheduled-edit",
      path: "/service-work-orders/:workOrderID/schedule/:scheduledStart/:scheduledEnd/:assignedTechs/:assignedVehicles",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Work Order"),
      },
      component: () => import("../../../dialogs/employee/ServiceWorkOrderEdit"),
    },
    {
      name: "service-work-order-edit",
      path: "/service-work-orders/:workOrderID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Work Order"),
      },
      component: () => import("../../../dialogs/employee/ServiceWorkOrderEdit"),
    },
    {
      // The technician reporting something found during service. Routed like
      // every other dialog so the URL reflects it and Back closes it; it also
      // links the new issue onto the work order, which service-issue-new does
      // not do.
      name: "technician-issue-report",
      path: "/service-work-orders/:workOrderID/report-issue",
      meta: {
        icon: "issue",
        title: i18n.global.t("Report New Issue"),
      },
      component: () =>
        import("../../../dialogs/employee/TechnicianIssueReport"),
    },
    {
      name: "service-work-order-complete",
      path: "/service-work-orders/:workOrderID/complete",
      meta: {
        icon: "done_all",
        title: i18n.global.t("Complete Service"),
      },
      component: () =>
        import("../../../dialogs/employee/ServiceWorkOrderComplete"),
    },
    {
      name: "service-work-order-loading",
      path: "/service-work-orders/:workOrderID/loading",
      meta: {
        icon: "loading",
        title: i18n.global.t("Load Parts"),
      },
      component: () =>
        import("../../../dialogs/employee/ServiceWorkOrderLoading"),
    },
    {
      name: "service-work-order-checklist",
      path: "/service-work-orders/:workOrderID/checklist",
      meta: {
        icon: "task",
        title: i18n.global.t("Service Checklist"),
      },
      component: () =>
        import("../../../dialogs/employee/ServiceWorkOrderChecklist"),
    },
    {
      name: "add-punchout",
      path: "/punchout/new/:projectID",
      meta: {
        icon: "calendar",
        title: i18n.global.t("Schedule Punchout"),
      },
      component: () => import("../../../dialogs/employee/AddPunchOut"),
    },
    {
      name: "knowledge-base-new",
      path: "/knowledge-base/new",
      meta: {
        icon: "add",
        title: i18n.global.t("New Knowledge Base Entry"),
      },
      component: () => import("../../../dialogs/employee/KnowledgeBaseEdit"),
    },
    {
      name: "knowledge-base-edit",
      path: "/knowledge-base/:entryID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Entry"),
      },
      component: () => import("../../../dialogs/employee/KnowledgeBaseEdit"),
    },
    {
      name: "knowledge-base-view",
      path: "/knowledge-base/:entryID/view",
      meta: {
        icon: "help",
        title: i18n.global.t("Knowledge Base Entry"),
      },
      component: () => import("../../../dialogs/employee/KnowledgeBaseView"),
    },
  ],
};
